import classnames from 'classnames';
import React, { FC } from 'react';
import styles from './TrunkSearchQuery.scss';
import { IOuter } from './TrunkSearchQuery.types';

export const TrunkSearchQuery: FC<IOuter> = ({ searchQuery, wrapperClassName, children }) => (
  <span className={classnames(styles.wrapper, wrapperClassName)}>
    {children({
      searchQuery: (
        <span className={styles.query} title={searchQuery}>
          {searchQuery}
        </span>
      ),
    })}
  </span>
);
